import React, { useState } from 'react';
import { QuoteForm } from './components/QuoteForm';
import { ProposalView } from './components/Proposal/ProposalView';
import { QuoteData } from './types';
// Default data based on the reference image
const defaultQuoteData: QuoteData = {
  borrowerFirstName: 'Alex',
  loName: 'Jordan Rivers',
  loNmls: '1029384',
  loPhone: '(555) 201-7733',
  loEmail: 'jordan.rivers@example-lending.com',
  propertyValue: 250000,
  loanType: 'Conventional',
  lenderName: 'Sample Mortgage Co.',
  refinanceType: 'Cash-Out',
  currentRate: 8.125,
  currentPayment: 1017,
  currentBalance: 137000,
  currentTerm: 30,
  currentProduct: '30-year fixed',
  proposedRate: 6.999,
  proposedPayment: 1397,
  proposedLoanAmount: 210000,
  proposedTerm: 30,
  cashToBorrower: 60000,
  daysToClose: 12,
  liabilities: [{
    id: 'liab-1',
    debtName: 'Credit Card',
    creditor: 'Chase Sapphire',
    currentBalance: 8500,
    monthlyPayment: 245,
    beingPaidOff: true
  }, {
    id: 'liab-2',
    debtName: 'Auto Loan',
    creditor: 'Capital One Auto',
    currentBalance: 18200,
    monthlyPayment: 412,
    beingPaidOff: true
  }, {
    id: 'liab-3',
    debtName: 'Student Loan',
    creditor: 'Nelnet',
    currentBalance: 23400,
    monthlyPayment: 180,
    beingPaidOff: false
  }]
};
export function App() {
  const [view, setView] = useState<'form' | 'proposal'>('form');
  const [quoteData, setQuoteData] = useState<QuoteData>(defaultQuoteData);
  const handleGenerateProposal = (data: QuoteData) => {
    setQuoteData(data);
    setView('proposal');
  };
  const handleBackToEdit = () => {
    setView('form');
  };
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-0">
      {view === 'form' ? <QuoteForm initialData={quoteData} onSubmit={handleGenerateProposal} data-id="element-1" /> : <ProposalView data={quoteData} onBack={handleBackToEdit} data-id="element-2" />}
    </div>;
}